<div class="image" *ngIf="item" [ngStyle]="{
    left: item?.position[width >= 768 ? 'pc' : 'mobile'].left,
    top: item?.position[width >= 768 ? 'pc' : 'mobile'].top,
    overflow: 'visible',
    transform: 'translate(-'+item?.position[width >= 768 ? 'pc' : 'mobile'].left +', '+ '-'+item?.position[width >= 768 ? 'pc' : 'mobile'].top + ')'
}">
    <img [src]="mediaUrl + item?.media" alt="" [ngStyle]="{height: item?.size[width >= 768 ? 'pc' : 'mobile'].height,
        width: item?.size[width >= 768 ? 'pc' : 'mobile'].width, 'object-fit': item?.size[width >= 768 ? 'pc' : 'mobile'].fit}">
</div>